import React from 'react';
export const ModuleInclusionsSection = () => {
  const inclusions = ['30 páginas completas sin espacios vacíos', 'Teoría en lenguaje adolescente real', '3 protocolos de acción inmediata', 'Actividades prácticas con espacio para escribir', 'Diario guiado de 14 a 21 días', 'Caso práctico con historia real', 'Plan de acción semanal y mensual', 'Bibliografía científica APA 7ma edición'];
  return <section className="bg-white py-10 px-5 sm:px-10" data-id="element-191">
      <div className="max-w-[1100px] mx-auto" data-id="element-192">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-biosync-text mb-10" data-id="element-193">
          "Cada módulo incluye:"
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 max-w-4xl mx-auto" data-id="element-194">
          {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg" data-id="element-195">
              <span className="text-biosync text-xl shrink-0" data-id="element-196">✅</span>
              <span className="text-biosync-text font-bold text-sm sm:text-base" data-id="element-197">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};